// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentModalBg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  z-index: 10;
}
.paymentModalBg .modalCont {
  background-color: var(--Foreground);
  width: 50%;
  padding: 0rem 1.25rem;
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  gap: 2rem;
}
.paymentModalBg .modalCont .paymentMsg {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  justify-content: center;
}
.paymentModalBg .modalCont .paymentMsg h1 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--TextColor);
}
.paymentModalBg .modalCont .paymentMsg p {
  font-size: 0.8rem;
  color: var(--TextColor);
}
.paymentModalBg .modalCont .paymentMsg div {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.paymentModalBg .modalCont .paymentMsg div button {
  width: 7rem;
  text-align: center;
  border-radius: 0.3rem;
  outline: none;
  padding: 0.6rem 0rem;
}
.paymentModalBg .modalCont .paymentMsg div button:nth-child(1) {
  border: 1px solid #B2B2B2;
  color: var(--TextColor);
}
.paymentModalBg .modalCont .paymentMsg div button:nth-child(2) {
  background-color: var(--AccentColor);
  color: white;
  border: none;
}

@media (min-width: 650px) and (max-width: 920px) {
  .modalCont img {
    width: 12rem;
    height: 12rem;
  }
  .modalCont .paymentMsg {
    padding: 1rem 0rem;
  }
  .modalCont .paymentMsg h1 {
    text-wrap: pretty;
  }
  .modalCont .paymentMsg button {
    width: 5rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 650px) {
  .modalCont {
    flex-direction: column;
    max-width: 80%;
    max-height: 80%;
  }
  .modalCont img {
    width: 15rem;
    height: 15rem;
  }
  .modalCont .paymentMsg {
    padding: 1rem 0rem;
    align-items: center;
  }
  .modalCont .paymentMsg p {
    text-align: center;
    text-wrap: pretty;
  }
  .modalCont .paymentMsg h1 {
    text-wrap: pretty;
  }
  .modalCont .paymentMsg button {
    width: 4rem;
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/ReusableComponents/PaymentModal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,WAAA;AACJ;AAAI;EACI,mCAAA;EACA,UAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAER;AADQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;AAGZ;AAFY;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;AAIhB;AAFY;EACI,iBAAA;EACA,uBAAA;AAIhB;AADY;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAGhB;AAFgB;EACI,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,oBAAA;AAIpB;AAHoB;EACI,yBAAA;EACA,uBAAA;AAKxB;AAHoB;EACI,oCAAA;EACA,YAAA;EACA,YAAA;AAKxB;;AAGA;EAEQ;IAEI,YAAA;IACA,aAAA;EAFV;EAIM;IACI,kBAAA;EAFV;EAGU;IACI,iBAAA;EADd;EAGU;IACI,WAAA;IACA,iBAAA;EADd;AACF;AAKA;EAEI;IACI,sBAAA;IACA,cAAA;IACA,eAAA;EAJN;EAKM;IAEI,YAAA;IACA,aAAA;EAJV;EAMM;IACI,kBAAA;IACA,mBAAA;EAJV;EAKU;IACI,kBAAA;IACA,iBAAA;EAHd;EAKU;IACI,iBAAA;EAHd;EAKU;IACI,WAAA;IACA,iBAAA;EAHd;AACF","sourcesContent":[".paymentModalBg{\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0,0,0,.7);\n    backdrop-filter: blur(5px);\n    z-index: 10;\n    .modalCont{\n        background-color: var(--Foreground);\n        width: 50%;\n        padding: 0rem 1.25rem;\n        border-radius: 1.25rem;\n        display: flex;\n        align-items: center;\n        gap: 2rem;\n        .paymentMsg{\n            display: flex;\n            flex-direction: column;\n            gap: 1.25rem;\n            justify-content: center;\n            h1{\n                font-size: 1.25rem;\n                font-weight: 600;\n                color: var(--TextColor);\n            }\n            p{\n                font-size: .8rem;\n                color: var(--TextColor);\n            }\n\n            div{\n                display: flex;\n                gap: 1rem;\n                align-items: center;\n                button{\n                    width: 7rem;\n                    text-align: center;\n                    border-radius: .3rem;\n                    outline: none;\n                    padding: .6rem 0rem;\n                    &:nth-child(1){\n                        border:1px solid #B2B2B2;\n                        color: var(--TextColor);\n                    }\n                    &:nth-child(2){\n                        background-color: var(--AccentColor);\n                        color: white;\n                        border: none;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media (min-width: 650px) and (max-width: 920px) {\n    .modalCont {\n        img{\n\n            width: 12rem;\n            height: 12rem;\n        }\n        .paymentMsg{\n            padding: 1rem 0rem;\n            h1{\n                text-wrap: pretty;\n            }\n            button{\n                width: 5rem;\n                font-size: .9rem;\n            }\n        }\n    }\n}\n@media (max-width: 650px) {\n    \n    .modalCont {\n        flex-direction: column;\n        max-width: 80%;\n        max-height: 80%;\n        img{\n\n            width: 15rem;\n            height: 15rem;\n        }\n        .paymentMsg{\n            padding: 1rem 0rem;\n            align-items: center;\n            p{\n                text-align: center;\n                text-wrap: pretty;\n            }\n            h1{\n                text-wrap: pretty;\n            }\n            button{\n                width: 4rem;\n                font-size: .8rem;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
